import { useState, useEffect, createContext, useContext } from 'react'
import * as Sentry from '@sentry/react'
import { apiFetch } from './auth'

const DEFAULTS = {
  diesel_price_eur: '1.14',
  currency: 'EUR',
  theft_threshold_l: '10',
  refuel_threshold_l: '20',
  low_fuel_threshold_l: '50',
  refresh_interval_s: '30',
  company_name: 'Tankguard'
};

export async function getSettings() {
  return apiFetch('/settings');
}

export async function updateSettings(updates) {
  return apiFetch('/settings', { method: 'PUT', body: JSON.stringify(updates) });
}

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  async function reload() {
    try {
      const rows = await getSettings();
      if (!rows) return; // 401 → logout already triggered
      const map = { ...DEFAULTS };
      rows.forEach(r => { map[r.key] = r.value; });
      setSettings(map);
    } catch (e) { console.error('Settings load failed:', e); Sentry.captureException(e); }
    setLoaded(true);
  }

  useEffect(() => { reload(); }, []);

  const value = {
    ...settings,
    diesel: parseFloat(settings.diesel_price_eur) || 1.14,
    theftThreshold: parseFloat(settings.theft_threshold_l) || 10,
    refuelThreshold: parseFloat(settings.refuel_threshold_l) || 20,
    lowFuelThreshold: parseFloat(settings.low_fuel_threshold_l) || 50,
    refreshMs: (parseInt(settings.refresh_interval_s) || 30) * 1000,
    company: settings.company_name || 'Tankguard',
    loaded,
    reload
  };

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be inside SettingsProvider');
  return ctx;
}

export function clearSettingsCache() { /* no-op, context handles this */ }
